import { render } from "./BaseSpinner.vue?vue&type=template&id=69628788&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=69628788&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69628788"]])

export default __exports__